exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader .el-upload[data-v-15e13bfe]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-15e13bfe]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-15e13bfe]{font-size:28px;color:#8c939d;width:100px;height:100px;line-height:100px;text-align:center}.avatar[data-v-15e13bfe]{width:100px;height:100px;display:block}.rule-input[data-v-15e13bfe]  .el-input__inner{border:0}\n", ""]);

// exports
